import React from "react";
import ChatSend from "./ChatSend";
import ChatReceive from "./ChatReceive";
import SVG from "react-inlinesvg";

import search from '../../../assets/svg/actions/icn-search.svg';
import menu from '../../../assets/svg/actions/icn-overflow-menu.svg';

import {Dropdown, Form, InputGroup} from "react-bootstrap";
import SimpleScrollbar from "../custom_scrollbars/SimpleScrollbar";
import ChatBubbles from "./ChatBubbles";
import InputGroupAnimated from "../forms/InputGroupAnimated";
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";

class ChatsContent extends React.Component {

    shadowScrollbarsRef = React.createRef();
    chatMessagesAreaRef = React.createRef();
    chatBubblesRef = React.createRef();

    messsagesContent = () => {
        var discussion = this.props.data.discussion;
        var messages =  discussion.map((item) => {
            return item.type == 'send' ? (
                <ChatSend data={item}></ChatSend>
            ) : (
                <ChatReceive data={item}></ChatReceive>
            )
        });

        if(discussion.length) {
            return (
                // className="chat-messages-scroll" maxHeight="calc(100vh - 330px)" scrollbottom="true"
                <ShadowScrollbars ref={this.shadowScrollbarsRef}>
                    <div ref={this.chatMessagesAreaRef} className="chat-messages-scroll">
                        {messages}
                    </div>
                </ShadowScrollbars>
            )
        } else {
            return this.blankArea();
        }
    }

    blankArea = () => {}

    onChatBubbleSubmit = (event, data) => {
        if(this.props.onChatBubbleSubmit)
            this.props.onChatBubbleSubmit(event, this.props.name, data);
    }

    onAttachmentSubmit = (event, data) => {
        if(this.props.onChatBubbleAttachmentSubmit)
            this.props.onChatBubbleAttachmentSubmit(event, this.props.name, data);
    }

    chatDropdownMenuContent = () => {}

    chatDropdownMenu = () => {
        return (
            <Dropdown className="dropdown-default" alignRight>
                <Dropdown.Toggle variant="default">
                    <a href="#"><i><SVG src={menu}/></i></a>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {this.chatDropdownMenuContent()}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    getMemberInfo = () => {}

    addExtraActions = () => {}

    addSearchbox = () => {
        return (
            <InputGroupAnimated className="input input-flat input-lg" placeholder="Seach Chat" icon={search}/>
        )
    }

    render() {
        return (
            <div className="chats-wrapper">
                <div className="chat-header">
                    <div className="member-info">
                        {this.getMemberInfo()}
                    </div>
                    <div className="member-actions">
                        {this.addSearchbox()}
                        {this.addExtraActions()}
                        {this.chatDropdownMenu()}
                    </div>
                </div>
                <div className="chat-body">
                    <div className="chat-messages">
                        {this.messsagesContent()}
                    </div>
                    <div className="chat-send-wrapper">
                        <ChatBubbles ref={this.chatBubblesRef} onSubmit={this.onChatBubbleSubmit} onAttachmentSubmit={this.onAttachmentSubmit}/>
                    </div>
                </div>
            </div>
        )
    }
};

export default ChatsContent;
